import { createContext } from 'react';

import { RoverBrandContextType } from '@rover/types';

const RoverBrandContext = createContext<RoverBrandContextType | null>(null);

export default RoverBrandContext;
